export default "__VITE_ASSET__KbIQKJJt__"